export interface ParsedCoachingMessage {
	/** The text following "Say this:" — the suggestion to speak aloud. */
	suggestion: string;
	/** Any remaining paragraphs after the suggestion — the coach's reasoning. */
	reasoning: string;
}

/**
 * Parses an AI coaching message to extract a "Say this:" suggestion from reasoning text.
 * Returns null if the message does not follow the pattern.
 */
export const parseCoachingMessage = (text: string): ParsedCoachingMessage | null => {
	const trimmed = text.trimStart();
	const match = trimmed.match(/^say this:\s*/i);
	if (!match) return null;

	const withoutPrefix = trimmed.slice(match[0].length);
	const paragraphs = withoutPrefix.split(/\n\n+/);

	return {
		suggestion: paragraphs[0].trim(),
		reasoning: paragraphs.slice(1).join('\n\n').trim(),
	};
};
